/**
 * All routes, as react-router route objects (rendered by useRoutes in App).
 *
 * Rules (see apps/web/README.md):
 *  - The phone capture path is imported eagerly — it must start offline.
 *  - Desk-only areas use `lazyPage(...)` so they are separate chunks
 *    (analyst review, findings, overdue, dashboard with recharts, admin and
 *    the template builder with dnd-kit).
 *  - Desk screens live in routes.desk.tsx and admin screens in routes.admin.tsx,
 *    so each work stream edits only its own route file.
 */
import type { RouteObject } from '../lib/router';
import { CaptureOverviewPage, CaptureSectionPage, SubmitReviewPage } from '../features/capture/CapturePages';
import { HomePage } from '../features/home/HomePage';
import { NotFound } from '../features/placeholders/NotFound';
import { ProfilePage } from '../features/profile/ProfilePage';
import { ReportEventPage } from '../features/events/ReportEventPage';
import { SitePage, SitesPage } from '../features/sites/SitesPages';
import { SurveyOpenPage, SurveysPage } from '../features/surveys/SurveysPages';
import { ADMIN_ROUTES } from './routes.admin';
import { DESK_ROUTES } from './routes.desk';

export const ROUTES: RouteObject[] = [
  // Phone capture path (eager)
  { path: '/', element: <HomePage /> },
  { path: '/sites', element: <SitesPage /> },
  { path: '/sites/:id', element: <SitePage /> },
  { path: '/surveys', element: <SurveysPage /> },
  { path: '/surveys/:id', element: <SurveyOpenPage /> },
  { path: '/capture/:draftId', element: <CaptureOverviewPage /> },
  { path: '/capture/:draftId/section/:code', element: <CaptureSectionPage /> },
  { path: '/capture/:draftId/review', element: <SubmitReviewPage /> },
  { path: '/profile', element: <ProfilePage /> },
  // Hazard / incident reporting works offline like capture (ADR-0029).
  { path: '/report', element: <ReportEventPage /> },

  ...DESK_ROUTES,
  ...ADMIN_ROUTES,

  { path: '*', element: <NotFound /> },
];
